<template>
  <div>
    <el-dialog :title="title" :visible.sync="showDialog" append-to-body @close="onClose" width="30%">

      <el-form ref="formDataRef" :model="formData" label-width="110px" inline :rules="rules" size="mini">
        <el-form-item label="司机名称" prop="name">
          <el-input v-model="formData.name" :disabled="contactId?true:false" clearable placeholder="请输入司机名称" style="width:230px" />
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="formData.mobile" placeholder="请输入手机号" clearable style="width:230px" />
        </el-form-item>
        <el-form-item label="身份证号" prop="identityNo">
          <el-input v-model="formData.identityNo" :disabled="contactId?true:false" clearable placeholder="请输入身份证号" style="width:230px" />
        </el-form-item>
        <template v-if="title==='新增司机'">
          <el-form-item label="车牌号" prop="plateNo" :rules="[{required:isRequired,message:'请输入车牌号',trigger:'change'}]">
            <el-input v-model="formData.plateNo" placeholder="请输入车牌号" clearable style="width:230px" />
          </el-form-item>
          <el-form-item label="车辆类型" prop="vehicleId" :rules="[{required:isRequired,message:'请选择车辆类型',trigger:'change'}]">
            <plt-dict-select v-model="formData.vehicleId" namespace="logistic" id="vehicleType" placeholder="请选择车辆类型" size="small" style="width:230px" />
          </el-form-item>
        </template>
      </el-form>

      <template #footer>
        <el-button @click="onClose" size="mini">取消</el-button>
        <el-button type="primary" @click="onSubmit" size="mini">确定</el-button>
      </template>

    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isRequired: false,
      title: "新增司机",
      showDialog: false,
      formData: {
        carrierId: sessionStorage.getItem("memberId"),
        name: "",
        mobile: "",
        identityNo: "",
        plateNo: "",
        vehicleId: ""
      },
      contactId: "",
      rules: {
        name: [{ required: true, message: "请输入司机名称" }],
        mobile: [{ required: true, message: "请输入手机号" }]
      }
    };
  },
  watch: {
    "formData.plateNo": async function(val) {
      this.isRequired = val || this.formData.vehicleId ? true : false;
      await this.$refs["formDataRef"].validateField("plateNo");
      await this.$refs["formDataRef"].validateField("vehicleId");
    },
    "formData.vehicleId": async function(val) {
      this.isRequired = val || this.formData.plateNo ? true : false;
      await this.$refs["formDataRef"].validateField("vehicleId");
      await this.$refs["formDataRef"].validateField("plateNo");
    }
  },
  methods: {
    openDialog(row = null) {
      this.showDialog = true;
      if (row?.contactId) {
        this.$nextTick(() => {
          this.formData.name = row.name;
          this.formData.mobile = row.mobile;
          this.formData.identityNo = row.identityNo;
          this.contactId = row.contactId;
          this.title = "修改司机";
        });
      }
    },
    onClose() {
      this.$refs["formDataRef"].resetFields();
      this.contactId = "";
      this.showDialog = false;
      this.title = "新增司机";
      this.isRequired = false;
    },
    async onSubmit() {
      let validate = await this.$refs["formDataRef"].validate();
      if (!validate) return;

      let url = "http://CORE-MEMBER/messageService/logisticsDriverService/addLogisticsDriver";

      this.formData.identityNo = this.formData.identityNo ? this.formData.identityNo : null;
      let params = this.formData;

      if (this.contactId) {
        url = "http://CORE-MEMBER/messageService/logisticsDriverService/updateLogisticsDriver";
        params = {
          contactId: this.contactId,
          mobile: this.formData.mobile
        };
      }

      this.cfmInvoke(url, params).then((res) => {
        this.$message.success("操作成功");
        this.onClose();
        this.$emit("onFinish");
      });
    }
  }
};
</script>